import React from 'react'
import styled from 'styled-components'
import {Icon} from '@startlibs/components'
import {getColor} from '@startlibs/utils'

export const SuccessIcon = styled(Icon)`
  background: ${getColor('success')};
  width: 18px;
  height: 18px;
  line-height: 19px;
  border-radius: 50%;
  color: white;
  display: block;
  margin-top: -2px;
  font-size: 14px;
  text-align: center;
`
